
<div *ngIf="isLoading">
    <app-loading-spinner></app-loading-spinner>
  </div>
  
<div class="w-50 m-auto">
    <h2 class="my-4">Login Form</h2>
<form action="" [formGroup]='loginForm' (ngSubmit)='getLoginInfo(loginForm)'>




    
        <div class="form-group">
            <label for="">Email :</label>
            <input [class.is-valid] = "loginForm.get('email').errors == null &&loginForm.get('email').touched" formControlName='email' type="email" class="form-control">
            <p *ngIf="loginForm.get('email').errors != null &&loginForm.get('email').touched  "  class="py-2 text-danger">Email Invalid</p>
            </div>
    

    
            <div class="form-group">
                <label for="">Password :</label>
                <input [class.is-valid] = "loginForm.get('password').errors == null &&loginForm.get('password').touched" formControlName='password' type="password" class="form-control">
                <p *ngIf="loginForm.get('password').errors != null &&loginForm.get('password').touched  "  class="py-2 text-danger">password Invalid</p>
                </div>
            <div class="text-center mb-4">
                 <button [disabled]='loginForm.invalid' type="submit" class="btn btn-mine text-white d-inline">Login</button>
            </div>

</form>
    <div *ngIf='flag' class="alert alert-danger m-auto">
        {{errorMessage}}
    </div>
